import { Component } from '@angular/core';
import { Router} from '@angular/router';
import { ModalController } from '@ionic/angular';
import { LoginMemberPage } from '../auth/login-member/login-member.page';
import{ApiService} from '../services/api.service';
@Component({
  selector: 'app-tab2',
  templateUrl: 'tab-member.page.html',
  styleUrls: ['tab-member.page.scss']
})
export class TabMemberPage {
	constructor(private router:Router, public modalController: ModalController, private api:ApiService)
	{
		
	}
	onInit()
	{
		this.cekLogin();
	}
	ionViewDidEnter(){    	
    	this.cekLogin();
	}
	userData:any={};
	cekLogin()
	{
		this.api.data('user/me','get','').subscribe(data=>{
	      this.gotopage(data);
	    },error=>{
	        this.router.navigate(['/page/tabs/member']);
	    })
	}
	gotopage(data)
	{
		if(data.role=='parent')
		{
		  this.router.navigate(['/page/tabs/member/parent']);
		}
		if(data.role=='teacher')
		{
		  this.router.navigate(['/page/tabs/member/teacher']);
		}		
	}
	async presentModal() {
    const modal = await this.modalController.create({
      component: LoginMemberPage,
    });
    return await modal.present();
  }
}
